type CommunityChannelIdentity = {
  id: string;
  channel_id: string;
};

export function resolveCommunityChannelDeepLink<T extends CommunityChannelIdentity>(
  target: string,
  carouselChannels: readonly T[],
  fallbackChannels: readonly T[],
): T | undefined {
  const matchesTarget = (channel: T) => (
    channel.channel_id === target || channel.id === target
  );

  return carouselChannels.find(matchesTarget) ?? fallbackChannels.find(matchesTarget);
}
